module.exports = __webpack_public_path__ + "static/ys-9fa9262913bc44fe08a2b827f90a41d1.png";